export default __webpack_public_path__ + "static/media/footer-instagram.1b092ae7.svg";